import { render, staticRenderFns } from "./ServiceDetailsTable.vue?vue&type=template&id=26d3901a&scoped=true&"
import script from "./ServiceDetailsTable.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d3901a",
  null
  
)

export default component.exports